/**
 * Created by hp on 2017/6/23.
 */
const defaults = {
    initialized: false,
    showDiscountDialog: false,
    showSubscribedDialog: false,
    discount: {},
    showPayPanel: false,
    subscribedQrcode: '',
    priceRecordId: 0,
    priceRecordMoney: 0,
    showPushDialog: false,
    pushObj: {},
    showMonthGiftDialog: false,
    showDelChannelDialog: false,
    showDelChannelSuccessDialog: false,
    lectureFinish: false,
    showOperatePanel: false,
    spCallbackUrl: '',
    spTransactionId: '',
    channelGroupBuyList: [],
    isShowGroupBuyListModal: false,
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'CHANNEL_INIT':
            return {...state, initialized: true, ...action.payload};
        case 'CHANNEL_COURSE_ACCESS_INIT':
            return {...state,...action.payload};
        case 'CHANNEL_SP_INIT':
            const {spCallbackUrl, spTransactionId} = action.payload;
            return {...state, spCallbackUrl, spTransactionId};
        case 'CHANNEL_SET_FAVOURITE':
            state.role.is_favorited = action.payload == null ? true : action.payload;
            return {...state};
        case 'CHANNEL_UNSET_FAVOURITE':
            state.role.is_favorited = false;
            return {...state};
        case 'CHANNEL_SHOW_DISCOUNT_DIALOG':
            return {...state, showDiscountDialog: true};
        case 'CHANNEL_HIDE_DISCOUNT_DIALOG':
            return {...state, showDiscountDialog: false};
        case 'CHANNEL_SET_DISCOUNT':
            return {...state, discount: action.payload};
        case 'CHANNEL_SHOW_PAY_PANEL':
            return {...state, showPayPanel: true};
        case 'CHANNEL_HIDE_PAY_PANEL':
            return {...state, showPayPanel: false};
        case 'CHANNEL_SELECT_MONTH_PAY':
            const monthId = parseInt(action.payload.priceRecordId, 10);
            const monthMoney = parseInt(action.payload.priceRecordMoney, 10);
            const priceList = state.channel.price_list.map((item) => {
                item.selected = item.id === monthId ;
               return item;
            });
            state.channel.price_list = priceList;
            state.channel.money = monthMoney;
            return {...state, ...state.channel, priceRecordId: monthId, priceRecordMoney: monthMoney};
        case 'CHANNEL_SHOW_SUBSCRIBED_DIALOG':
            return {...state, showSubscribedDialog: true};
        case 'CHANNEL_HIDE_SUBSCRIBED_DIALOG':
            return {...state, showSubscribedDialog: false};
        case 'CHANNEL_SET_SUBSCRIBED_QRCODE':
            return {...state, subscribedQrcode: action.payload};
        case 'CHANNEL_SUBSCRIBED_CHANNEL':
            state.channel_access.subscribed = true;
            return {...state, channel_access: state.channel_access};
        case 'CHANNEL_SHOW_PUSH_DIALOG':
            return {...state, showPushDialog: true, pushObj: action.payload};
        case 'CHANNEL_HIDE_PUSH_DIALOG':
            return {...state, showPushDialog: false};
        case 'CHANNEL_SET_PUSH_OBJ':
            return {...state, pushObj: action.payload};
        case 'CHANNEL_SET_FANS':
            state.role.is_fans = true;
            return {...state, role: state.role};
        case 'CHANNEL_UNSET_FANS':
            state.role.is_fans = false;
            return {...state, role: state.role};
        case 'CHANNEL_SHOW_MONTH_GIFT_DIALOG':
            return {...state, showMonthGiftDialog: true};
        case 'CHANNEL_HIDE_MONTH_GIFT_DIALOG':
            return {...state, showMonthGiftDialog: false};
        case 'CHANNEL_HIDE_DEL_CHANNEL_DIALOG':
            return {...state, showDelChannelDialog: false};
        case 'CHANNEL_SHOW_DEL_CHANNEL_DIALOG':
            return {...state, showDelChannelDialog: true};
        case 'CHANNEL_HIDE_DEL_CHANNEL_SUCCESS_DIALOG':
            return {...state, showDelChannelSuccessDialog: false};
        case 'CHANNEL_SHOW_DEL_CHANNEL_SUCCESS_DIALOG':
            return {...state, showDelChannelSuccessDialog: true};
        case 'CHANNEL_NEW_LECTURE_LIST':
            return {...state, lectureFinish: true, lectures: action.payload};
        case 'CHANNEL_SHOW_OPERATE_PANEL':
            return {...state, showOperatePanel: true};
        case 'CHANNEL_HIDE_OPERATE_PANEL':
            return {...state, showOperatePanel: false};
        case 'CHANNEL_SET_GROUP_BUY_LIST':
            return {...state, channelGroupBuyList: action.payload};
        case 'CHANNEL_SET_IS_SHOW_GROUP_BUY_LIST_MODAL':
            return {...state, isShowGroupBuyListModal: action.payload};
        case 'CHANNEL_SVIP_SUCCESS':
            state.channel_access.granted = true;
            return {...state, channel_access: Object.assign({}, state.channel_access)};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/channel.js